
const awsconfig =  {
    "aws_appsync_graphqlEndpoint": "https://settingapidev.rovelabs.com/graphql",
    "aws_appsync_region": "ap-south-1",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS",
    "aws_appsync_apiKey": "da2-57aog5lbhneddaozu22nfcpv7y",
};

export default awsconfig;